import type { ProductFeedbackCategory, ProductFeedbackStatus } from '../types/productFeedback';

export const PRODUCT_FEEDBACK_CATEGORY_OPTIONS: ReadonlyArray<{
  value: ProductFeedbackCategory;
  label: string;
}> = [
  { value: 'bug', label: 'Błąd działania' },
  { value: 'ux_problem', label: 'Problem z obsługą' },
  { value: 'visual_issue', label: 'Problem wizualny' },
  { value: 'suggestion', label: 'Sugestia' },
];

const CATEGORY_LABELS: Record<ProductFeedbackCategory, string> = Object.fromEntries(
  PRODUCT_FEEDBACK_CATEGORY_OPTIONS.map(({ value, label }) => [value, label])
) as Record<ProductFeedbackCategory, string>;

const STATUS_LABELS: Record<ProductFeedbackStatus, string> = {
  open: 'Otwarte',
  investigating: 'W analizie',
  resolved: 'Rozwiązane',
};

const STATUS_NARRATIVES: Record<ProductFeedbackStatus, string> = {
  open: 'Zgłoszenie zostało przyjęte i oczekuje na analizę.',
  investigating: 'Zespół analizuje zgłoszenie.',
  resolved: 'Zgłoszenie zostało rozwiązane.',
};

export const getProductFeedbackCategoryLabel = (category: ProductFeedbackCategory): string =>
  CATEGORY_LABELS[category];

export const getProductFeedbackStatusLabel = (status: ProductFeedbackStatus): string =>
  STATUS_LABELS[status];

export const getProductFeedbackStatusNarrative = (status: ProductFeedbackStatus): string =>
  STATUS_NARRATIVES[status];
